import React from 'react';
import Header from '../component/layout/Header';
import Hero from '../component/shippers/Hero';
import Intro from '../component/shippers/Intro';
import App from '../component/shippers/App';
// import Features from '../component/shippers/Features';
import Testimonials from '../component/shippers/Testimonials';
import CTA from '../component/shippers/CTA';
import Footer from '../component/layout/Footer';

export default function Shippers() {
  return (
    <div>
      <Header />
      <Hero />
      <Intro />
      <App />
      {/* <Features /> */}
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  )
}